import React from 'react';
import ReactDOM from "react-dom";
import SessionTimeoutWarning from "./SessionTimeoutWarning";

// Returns {elementID} in the dom, if not present creates a div element specified by {elementID} in the dom and returns it.
function createOrFindDocumentElement(elementID) {
    if (!document.getElementById(elementID)) {
        let newDiv =  document.createElement('div');
        newDiv.id = elementID;
        document.body.appendChild(newDiv);
    }
    return document.getElementById(elementID);
}

window.addEventListener('DOMContentLoaded', function pollBackend() {
    if (sfTenant.getTenantConfig('SESSION_TIMEOUT_WARNING_ENABLED') && sfUser && sfUser.partyId)
        ReactDOM.render(<SessionTimeoutWarning />, createOrFindDocumentElement("ping-timeout"));
});
